document.addEventListener("collection-grid-update", () => {
    console.log("Collection Updated");
    initInfiniteScroll();
});

let infiniteObserver = null;

function initInfiniteScroll() {

    const trigger = document.querySelector("#infinite-scroll-trigger");

    if (!trigger) return;

    const grid = document.querySelector("#collection-grid");
    const loader = document.querySelector("#infinite-loader");

    if (!grid) return;

    // Remove old observer if exists
    if (infiniteObserver) {
        infiniteObserver.disconnect();
    }

    let loading = false;

    infiniteObserver = new IntersectionObserver(async (entries) => {

        if (!entries[0].isIntersecting) return;
        if (loading) return;

        const nextPage = trigger.dataset.nextPage;

        if (!nextPage) return;

        loading = true;

        loader?.classList.remove("hidden");

        try {

            const response = await fetch(nextPage);
            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const newGrid = doc.querySelector("#collection-grid");

            if (newGrid) {
                grid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
            }

            const newTrigger = doc.querySelector("#infinite-scroll-trigger");

            if (newTrigger && newTrigger.dataset.nextPage) {

                trigger.dataset.nextPage = newTrigger.dataset.nextPage;

            } else {

                trigger.remove();
                infiniteObserver.disconnect();

            }

        } catch (error) {

            console.error("Infinite Scroll Error:", error);

        } finally {

            loader?.classList.add("hidden");
            loading = false;

        }

    }, {
        rootMargin: "200px"
    });

    infiniteObserver.observe(trigger);
}

document.addEventListener("DOMContentLoaded", initInfiniteScroll);

// Make it available globally
window.initInfiniteScroll = initInfiniteScroll;